import { I18nUtils } from '../../../i18n/I18nUtils';
import RouterUtils from '../routing/RouterUtils';
import { PsRoutes } from '../routing/Routes';

export class Breadcrumbs {

    static HOME = {
        id: 'home',
        url: RouterUtils.generateRoute(PsRoutes.HOME),
        loading: false,
        description: I18nUtils.tr('TR_INICIO'),
    };

    static CONTRACTORS = {
        id: 'contractors',
        url: RouterUtils.generateRoute(PsRoutes.CONTRACTORS),
        loading: false,
        description: I18nUtils.tr('TR_CONTRATISTAS'),
    };

    static CONTRACTORS_ADD = {
        id: 'contractors-add',
        url: RouterUtils.generateRoute(PsRoutes.CONTRACTORS_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVO_CONTRATISTA'),
    };

    static CONTRACTORS_DETAIL = {
        id: 'contractors-detail',
        url: '',
        loading: true,
        description: '',
    };

    static USERS = {
        id: 'users',
        url: RouterUtils.generateRoute(PsRoutes.USERS),
        loading: false,
        description: I18nUtils.tr('TR_USUARIOS'),
    };

    static USERS_ADD = {
        id: 'users-add',
        url: RouterUtils.generateRoute(PsRoutes.USERS_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVO_USUARIO'),
    };

    static USER_DETAIL = {
        id: 'user-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_CONTRACTORS = {
        id: 'my-contractors',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS),
        loading: false,
        description: I18nUtils.tr('TR_MIS_CONTRATISTAS'),
    };

    static MY_CONTRACTORS_DETAIL = {
        id: 'my-contractors-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_CONTRACTORS_WORKS = {
        id: 'my-contractors-works',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_WORKS),
        loading: false,
        description: I18nUtils.tr('TR_OBRAS'),
    };

    static MY_CONTRACTORS_WORKS_DETAIL = {
        id: 'my-contractors-works-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_CONTRACTORS_WORKERS = {
        id: 'my-contractors-workers',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_WORKERS),
        loading: false,
        description: I18nUtils.tr('TR_MIS_TRABAJADORES'),
    };

    static MY_CONTRACTORS_WORKERS_ADD = {
        id: 'my-contractors-workers-add',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_WORKERS_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVO_TRABAJADOR'),
    };

    static MY_CONTRACTORS_WORKERS_DETAIL = {
        id: 'my-contractors-workers-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_CONTRACTORS_MACHINES = {
        id: 'my-contractors-machines',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_MACHINES),
        loading: false,
        description: I18nUtils.tr('TR_MI_MAQUINARIA'),
    };

    static MY_CONTRACTORS_MACHINES_ADD = {
        id: 'my-contractors-machines-add',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_MACHINES_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVA_MAQUINA'),
    };

    static MY_CONTRACTORS_MACHINES_DETAIL = {
        id: 'my-contractors-machines-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_CONTRACTORS_DOCUMENTS = {
        id: 'my-contractors-documents',
        url: RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_DOCUMENTS),
        loading: false,
        description: I18nUtils.tr('TR_DOCUMENTOS'),
    };

    static MY_CONTRACTORS_OUTSOURCE_DOCUMENT_DETAIL = {
        id: 'my-contractors-outsource-document-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES = {
        id: 'my-outsources',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES),
        loading: false,
        description: I18nUtils.tr('TR_MIS_SUBCONTRATAS'),
    };

    static MY_OUTSOURCES_ADD = {
        id: 'my-outsources-add',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVA_SUBCONTRATA'),
    };

    static MY_OUTSOURCES_DETAIL = {
        id: 'my-outsources-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_WORKS = {
        id: 'my-outsources-works',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_WORKS),
        loading: false,
        description: I18nUtils.tr('TR_OBRAS'),
    };

    static MY_OUTSOURCES_WORKS_ADD = {
        id: 'my-outsources-works-add',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_WORKS_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVA_OBRA'),
    };

    static MY_OUTSOURCES_WORKS_DETAIL = {
        id: 'my-outsources-works-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_WORKERS = {
        id: 'my-outsources-workers',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_WORKERS),
        loading: false,
        description: I18nUtils.tr('TR_TRABAJADORES'),
    };

    static MY_OUTSOURCES_WORKERS_DETAIL = {
        id: 'my-outsources-workers-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_MACHINES = {
        id: 'my-outsources-machines',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_MACHINES),
        loading: false,
        description: I18nUtils.tr('TR_MAQUINARIA'),
    };

    static MY_OUTSOURCES_MACHINES_DETAIL = {
        id: 'my-outsources-machines-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_DOCUMENTS = {
        id: 'my-outsources-documents',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS),
        loading: false,
        description: I18nUtils.tr('TR_DOCUMENTOS'),
    };

    static MY_OUTSOURCES_OUTSOURCE_DOCUMENT_DETAIL = {
        id: 'my-outsources-outsource-document-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_DOCUMENTS_EMPTY = {
        id: 'my-outsources-documents-empty',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_DOCUMENTOS'),
    };

    static MY_OUTSOURCES_DOCUMENTS_EXPORT = {
        id: 'my-outsources-documents-export',
        url: '',
        loading: true,
        description: I18nUtils.tr('TR_EXPORTAR'),
    };

    static MY_OUTSOURCES_DOCUMENTS_EXPORT_CONFIRM = {
        id: 'my-outsources-documents-export-confirm',
        url: '',
        loading: true,
        description: I18nUtils.tr('TR_CONFIRMACION'),
    };

    static MY_OUTSOURCES_DOCUMENTS_TYPES = {
        id: 'my-outsources-documents-types',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES),
        loading: false,
        description: I18nUtils.tr('TR_TIPOS_DE_DOCUMENTOS'),
    };

    static MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL = {
        id: 'my-outsources-documents-types-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_DOCUMENTS_SCHEMES = {
        id: 'my-outsources-documents-schemes',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES),
        loading: false,
        description: I18nUtils.tr('TR_ESQUEMAS_DE_DOCUMENTOS'),
    };

    static MY_OUTSOURCES_DOCUMENTS_SCHEMES_DETAIL = {
        id: 'my-outsources-documents-schemes-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_MONTHLY = {
        id: 'my-outsources-monthly',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_MONTHLY),
        loading: false,
        description: I18nUtils.tr('TR_MENSUAL'),
    };

    static MY_OUTSOURCES_TASKS = {
        id: 'my-outsources-tasks',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_TASKS),
        loading: false,
        description: I18nUtils.tr('TR_TAREAS'),
    };

    static MY_OUTSOURCES_TASKS_ADD = {
        id: 'my-outsources-tasks-add',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_TASKS_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVA_TAREA'),
    };

    static MY_OUTSOURCES_PRESENCES_MONTHLY = {
        id: 'my-outsources-presences-monthly',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PRESENCES_MONTHLY),
        loading: false,
        description: I18nUtils.tr('TR_LISTERIA_MENSUAL'),
    };

    static MY_OUTSOURCES_PRESENCES_WORKS = {
        id: 'my-outsources-presences-works',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PRESENCES_WORKS),
        loading: false,
        description: I18nUtils.tr('TR_OBRAS'),
    };

    static MY_OUTSOURCES_PRESENCES_WORKS_DETAIL = {
        id: 'my-outsources-presences-works-detail',
        url: '',
        loading: true,
        description: '',
    };

    static MY_OUTSOURCES_PAPER_BIN = {
        id: 'my-outsources-paper-bin',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_PAPELERA'),
    };

    static MY_OUTSOURCES_PAPER_BIN_REMOVE = {
        id: 'my-outsources-paper-bin-remove',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE),
        loading: false,
        description: I18nUtils.tr('TR_ELIMINAR'),
    };

    static MY_OUTSOURCES_PAPER_BIN_REMOVE_CONFIRM = {
        id: 'my-outsources-paper-bin-remove-confirm',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PAPER_BIN_REMOVE_CONFIRM),
        loading: false,
        description: I18nUtils.tr('TR_CONFIRMACION'),
    };

    static MY_OUTSOURCES_PAPER_BIN_RECOVER = {
        id: 'my-outsources-paper-bin-recover',
        url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_PAPER_BIN_RECOVER),
        loading: false,
        description: I18nUtils.tr('TR_RECUPERAR'),
    };

    static PROFILE = {
        id: 'profile',
        url: RouterUtils.generateRoute(PsRoutes.PROFILE),
        loading: false,
        description: I18nUtils.tr('TR_PERFIL'),
    };

    static PROFILE_PASSWORD_EDIT = {
        id: 'profile-password-edit',
        url: RouterUtils.generateRoute(PsRoutes.PROFILE_PASSWORD_EDIT),
        loading: false,
        description: I18nUtils.tr('TR_CAMBIAR_CONTRASENA'),
    };

    static NOTIFICATIONS = {
        id: 'notifications',
        url: RouterUtils.generateRoute(PsRoutes.NOTIFICATIONS),
        loading: false,
        description: I18nUtils.tr('TR_NOTIFICACIONES'),
    };

    static MESSAGES = {
        id: 'messages',
        url: RouterUtils.generateRoute(PsRoutes.MESSAGES),
        loading: false,
        description: I18nUtils.tr('TR_MENSAJES'),
    };

    static MESSAGES_DETAIL = {
        id: 'messages-detail',
        url: '',
        loading: true,
        description: '',
    };

    static DOCUMENTS_ATTACHMENT = {
        id: 'documents-attachment',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_SUBIDA_MULTIPLE'),
    };

    static DOCUMENTS_ATTACHMENT_SUMMARY = {
        id: 'documents-attachment-summary',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_RESUMEN_SUBIDA_MULTIPLE'),
    };

    static DOCUMENTS_DETAIL = {
        id: 'documents-detail',
        url: '',
        loading: true,
        description: '',
    };

    static DOCUMENTS_EMPTY = {
        id: 'documents-empty',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_DOCUMENTOS'),
    };

    static WORKERS_EMPTY = {
        id: 'workers-empty',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_TRABAJADORES'),
    };

    static MACHINES_EMPTY = {
        id: 'machines-empty',
        url: '',
        loading: false,
        description: I18nUtils.tr('TR_MAQUINARIA'),
    };

    static DOCUMENTARY_LIBRARY = {
        id: 'documentary-library',
        url: RouterUtils.generateRoute(PsRoutes.DOCUMENTARY_LIBRARY),
        loading: false,
        description: I18nUtils.tr('TR_BIBLIOTECA_DOCUMENTAL'),
    }

    static DOCUMENTARY_LIBRARY_ADD = {
        id: 'documentary-library-add',
        url: RouterUtils.generateRoute(PsRoutes.DOCUMENTARY_LIBRARY_ADD),
        loading: false,
        description: I18nUtils.tr('TR_NUEVO_DOCUMENTO'),
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/breadcrumbs/Breadcrumbs.js